var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2409_34656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.669 0H4.33105C1.94287 0 0 1.94287 0 4.33105V11.6689C0 14.0571 1.94287 16 4.33105 16H11.669C14.0571 16 16 14.0571 16 11.6689V4.33105C16 1.94287 14.0571 0 11.669 0ZM15.062 11.6689C15.062 13.5399 13.5399 15.062 11.6689 15.062H4.33105C2.46008 15.062 0.937986 13.5399 0.937986 11.6689V11.6278L3.62829 9.15123C3.70446 9.08116 3.82385 9.08116 3.90002 9.15111L5.95861 11.041C6.19738 11.2602 6.51927 11.3673 6.84203 11.3352C7.16466 11.303 7.45897 11.134 7.64977 10.8718L11.2826 5.87658C11.3308 5.81041 11.3968 5.79662 11.4319 5.7943C11.4669 5.79223 11.5342 5.79699 11.5906 5.85643L15.0619 9.51426V11.6689H15.062ZM15.062 8.15172L12.271 5.21081C12.0375 4.96471 11.7097 4.83629 11.3707 4.85839C11.0322 4.88048 10.7236 5.05053 10.524 5.32494L6.8911 10.3202C6.84508 10.3834 6.78209 10.3985 6.74864 10.4018C6.71532 10.4051 6.65062 10.4029 6.59301 10.35L4.53442 8.46019C4.10192 8.06297 3.42492 8.06358 2.99304 8.46117L0.937986 10.3529V4.33105C0.937986 2.46008 2.46008 0.937986 4.33105 0.937986H11.669C13.5399 0.937986 15.062 2.46008 15.062 4.33105V8.15172Z",
    fill: "url(#paint0_linear_2409_34656)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46472 2.71045C3.55591 2.71045 2.81641 3.44995 2.81641 4.35888C2.81641 5.2677 3.55591 6.0072 4.46472 6.0072C5.37365 6.0072 6.11303 5.2677 6.11303 4.35888C6.11315 3.44995 5.37365 2.71045 4.46472 2.71045ZM4.46472 5.06909C4.07312 5.06909 3.75439 4.75048 3.75439 4.35876C3.75439 3.96716 4.07312 3.64844 4.46472 3.64844C4.85644 3.64844 5.17504 3.96704 5.17504 4.35876C5.17504 4.75048 4.85644 5.06909 4.46472 5.06909Z",
    fill: "url(#paint1_linear_2409_34656)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2409_34656",
    x1: 16.0514,
    y1: 20.7103,
    x2: -4.42462,
    y2: 13.5621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2409_34656",
    x1: 6.12363,
    y1: 6.97774,
    x2: 1.90473,
    y2: 5.50498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2409_34656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconimage);
export default __webpack_public_path__ + "static/media/iconimage.be5f73a925f84bdcdadbb9caf9aa6283.svg";
export { ForwardRef as ReactComponent };